import type { RestClientConfiguration } from '@teqplay/api'

import type { TRestContext } from './builder'
import { LoggerRequestHandler } from './handlers/LoggerRequestHandler'

const baseURL = (process.env.NEXT_PUBLIC_BACKEND_URL ?? 'http://localhost:8000') as `http${string}`

/**
 * Simple function to create REST client config with Auth0 access token support.
 * Works for both logged-in users (with access token) and anonymous users (no auth).
 *
 * @param accessToken - Optional Auth0 access token for authenticated requests
 * @returns RestClientConfiguration with access token if user is logged in
 */
export function createRestConfig(accessToken?: string): RestClientConfiguration<TRestContext> {
  const headers = new Headers([['Content-Type', 'application/json']])

  if (accessToken) {
    headers.set('Authorization', `Bearer ${accessToken}`)
  }

  return {
    baseURL,
    baseHeaders: headers,
    baseRequestHandler: new LoggerRequestHandler<TRestContext>()
  }
}
